module.exports = __webpack_public_path__ + "static/media/home-icon.25a80958.svg";